<template>
    <div v-if="!$route.fullPath.includes('contact') && !$store.state.changing" class="wrapper animateIn cta-animateIn">
        <section class="project-block call-to-action ">
            <h2 class="title">Itching to talk about your next project?</h2>
            <form @submit.prevent="processForm">
                <div class="row">
                    <p>Hi I'm <input id="name" type="text" v-model="name"/> and I'd like to talk to you about <multiselect v-model="subject" :options="['Website','Content Management System','Email Marketing','Social Media Marketing','E-Commerce','Branding','Print','Motion/Photography']" :show-labels="false" placeholder=""></multiselect>
                        <button type="submit">Next...</button>
                    </p>
                </div>
            </form>
            <router-link class="button mobile" to="/contact">Lets chat</router-link>
        </section>
    </div>
</template>

<script>
  import Multiselect from 'vue-multiselect'

  export default {
    components: {
      Multiselect
    },
    data () {
      return {
        name: '',
        subject: ''
      }
    },
    methods: {
      processForm () {
        this.$router.push(`/contact?name=${this.name}&subject=${this.subject}&showtalk=true`)
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/Signup/Signup.vue